/* NM v70.8 — carga el parallax decorativo sólo donde puede verse. */
(function () {
  "use strict";

  var owner =
    document.currentScript ||
    document.querySelector("script[data-nm-parallax-src]");
  if (!owner || !window.matchMedia) return;

  var desktopMotion = window.matchMedia(
    "(min-width: 990px) and (prefers-reduced-motion: no-preference)",
  );
  var loaded = false;

  function loadParallax() {
    if (loaded || !desktopMotion.matches) return;
    loaded = true;

    [
      owner.getAttribute("data-nm-gsap-src"),
      owner.getAttribute("data-nm-scroll-trigger-src"),
      owner.getAttribute("data-nm-parallax-src"),
    ].forEach(function (source) {
      if (!source) return;
      var script = document.createElement("script");
      script.src = source;
      script.async = false;
      script.setAttribute("data-nm-v708-parallax", "");
      document.head.appendChild(script);
    });
  }

  loadParallax();
  if (desktopMotion.addEventListener) {
    desktopMotion.addEventListener("change", loadParallax, { once: true });
  } else if (desktopMotion.addListener) {
    desktopMotion.addListener(loadParallax);
  }
})();
